import { useState, useEffect, useRef } from "react";
import "../../css/home1_2.css";

function HomeSection12() {
  const [displayText, setDisplayText] = useState("");
  const [showCaret, setShowCaret] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current; // Copy to variable
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasAnimated) {
          startTypingAnimation();
          setHasAnimated(true);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated]); // Only hasAnimated as dependency

  const startTypingAnimation = () => {
    const quote = '""Tu crecimiento no es casualidad, es estrategia."';
    let i = 0;
    setDisplayText("");
    setShowCaret(true);

    const typingInterval = setInterval(() => {
      if (i < quote.length) {
        setDisplayText(prev => prev + quote.charAt(i));
        i++;
      } else {
        clearInterval(typingInterval);
        setShowCaret(false);
      }
    }, 100);
  };

  return (
    <section id="section2" ref={sectionRef}>
      {/* Purple container with waves extending outside */}
      <div className="purple-container">
        {/* Top wave */}
        <div className="wave-top">
          <svg className="wave-svg" xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
            <defs>
              <filter id="wave-shadow" x="-50%" y="-50%" width="200%" height="200%">
                <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#000" floodOpacity="0.3" />
              </filter>
              <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(88,51,234)" filter="url(#wave-shadow)" />
            </g>
          </svg>
        </div>

        {/* Typing quote content */}
        <div className="container-content text-center mt-5 pt-5">
          <p className="h4">
            {displayText}
            {showCaret && <span className="caret">|</span>}
          </p>
        </div>

        {/* Bottom wave */}
        <div className="wave-bottom">
          <svg className="wave-svg" xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
            <defs>
              <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(88,51,234)" />
            </g>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default HomeSection12;